var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M8.22 12.393h-.44l.11-1.757c-.006-.092-.05-.117-.22-.11l-1.756.22s.33-.44.33-.659c0-.22-1.977-1.647-1.977-1.647s.439-.11.549-.22c.11-.11-.44-1.317-.44-1.317s1.116.44 1.208.33c.092-.11.22-.55.22-.55s.878.989 1.098.989c.22 0-.44-2.416-.44-2.416s.55.439.77.439C7.45 5.695 8 4.268 8 4.268s.549 1.427.659 1.427c.11 0 .878-.44.878-.44s-.549 2.307-.439 2.417c.11.11 1.098-.989 1.098-.989s.11.44.22.55c.11.11 1.207-.33 1.207-.33s-.549 1.208-.439 1.318c.11.11.55.22.55.22s-1.977 1.427-1.977 1.646c0 .22.22.659.22.659l-1.648-.22c-.132-.038-.178-.009-.22.11l.11 1.757ZM13.867 0H19.2v16h-5.333zM-3.2 0h5.333v16H-3.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    rx: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanFlag);
export default __webpack_public_path__ + "static/media/can-flag.0f3c6c469493726bf46645415559e3c8.svg";
export { ForwardRef as ReactComponent };